import React from 'react'
import IField from '../../../../interfaces/field'
import { Row } from '../../../ui'
import Input from '../input'
import Button from '../button'
import InputMask from '../input-mask'
import InputUpload from '../input-upload'
import InputRadio from '../input-radio'
import InputSwitch from '../input-switch'
import InputPhone from '../input-phone'
import SelectChecklist from '../select-checklist'
import InputPassword from '../input-password'
import Select from '../select'

type IProps = any & IField
const InputGroup = ({
  inputs,
  style,
  ...el
}: IProps): JSX.Element | null => (
  <Row style={{
    gap: '15px',
    alignItems: 'flex-start',
    ...style,
  }}
  >
    {
      inputs.map(({ component, value, ...rest }: any) => {
        const ComponentsList = {
          Input,
          InputMask,
          InputPassword,
          InputRadio,
          InputSwitch,
          InputPhone,
          InputUpload,
          SelectChecklist,
          Button,
          Select,
        }
        const Component = (ComponentsList as any)[component]
        const itemProps = { ...rest, ...el, value: value || '' }

        return (
          <Component
            key={rest.name}
            {...itemProps}
          />
        )
      })
    }
  </Row>
)

export default InputGroup
